import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { Link } from 'react-router-dom';

export const OrganizationNotFound = () => {
  return (
    <ChakraV3.Result
      status='error'
      title="You don't have access to any organizations"
      description='Your account is not a member of an organization. If you think this is a mistake, contact your organization administrator or Piccolo support.'
      extra={
        <Link to={'/logout'}>
          <ChakraV3.Button>Logout</ChakraV3.Button>
        </Link>
      }
    />
  );
};
